<ion-list class="background-color-muted">
  <form
    class="freebets-page--form background-color-muted"
    [formGroup]="form"
    *ngIf="freeBetSMSVerification() && phoneNumber()"
  >
    <div class="introReg">
      {{"fbverificamob01" | translate}}
      <!--Por favor, completa la verificación móvil para continuar-->
    </div>

    <div class="myWrapInput">
      <ion-input
        class="background-color-light"
        [label]="'fbverificamob02' | translate"
        labelPlacement="floating"
        [placeholder]="'aCSms' | translate"
        fill="outline"
        [(ngModel)]="modelForm.smsCode"
        [formControl]="$any(form).controls['smsCode']"
      ></ion-input>
    </div>

    <div class="sendForm">
      <button ion-button [full]="isMobile()" (click)="checkFBCode">OK</button>
    </div>

    <hr />

    <div class="introReg">
      <strong>{{"fbverificamob03" | translate}}</strong>
      <br />
      {{"fbverificamob04"| translate}} {{phoneNumber()}}
    </div>

    <div class="sendForm">
      <button ion-button [full]="isMobile()" (click)="reSendFBCode">{{"fbverificamob05" | translate}}</button>
    </div>
  </form>

  <div *ngIf="freeBetAccountVerification()" class="freebet-account-verification">
    <div class="introReg">{{"fbfreebets" | translate}}</div>
    <div class="sendForm">
      <button ion-button [full]="isMobile()" (click)="goToVer">{{"check" | translate}}</button>
    </div>
  </div>
</ion-list>